


























import { PROPOSED_PAYMENT_PERIOD, SCONTO } from '@/modules/layout/constants'
import PaymentPeriodUpdateDialog from './PaymentPeriodUpdateDialog.vue'

export default {
  components: {
    PaymentPeriodUpdateDialog
  },
  data() {
    return {
      proposedPaymentPeriod: PROPOSED_PAYMENT_PERIOD,
      sconto: SCONTO
    }
  },
  methods: {
    openPaymentPeriodUpdateDialog() {
      this.$refs.paymentDialog.open()
    }
  }
}
